export * from './btvClientServices.service';
import { BtvClientServicesService } from './btvClientServices.service';
export const APIS = [BtvClientServicesService];



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/data/cms-btv-client-api/api/api.ts